export default "__VITE_ASSET__DMfnTna5__"